import api from "../..";
import type {
  CreateGoldenChallengeChainBody,
  GoldenChallenge,
  PostGoldenChallengeChainParams,
  PostGoldenChallengeParams,
} from "./types";
import type { ApiResponse } from "../../types";

export const postGoldenChallenge = async ({ body }: PostGoldenChallengeParams): Promise<boolean> => {

  return await api.post<ApiResponse<GoldenChallenge>>("/admin/golden-challenges/", body)
  .then(() => true)
  .catch(() => false);
};

export const postGoldenChallengeChain = async ({ body }: PostGoldenChallengeChainParams): Promise<boolean> => {

  return await api.post<ApiResponse<CreateGoldenChallengeChainBody>>("/admin/challenges/chains/", body)
  .then(() => true)
  .catch(() => false);
};
